import type { MiseEnFormeControle } from '@rosetta/shared';

interface DetailMiseEnFormeProps {
  miseEnForme: MiseEnFormeControle;
}

/**
 * What the "Mise en forme" card details (indicator 3.2), in our words around Tahiti's numbers:
 * the paragraphs of the translation and of the text of origin (A8; the summary of Tahiti, "1
 * paragraphes pour 1", is not shown), then, only when Tahiti raises them, an invented title,
 * added markdown and leftovers. TO VALIDATE(#10): those three were never seen raised.
 */
export function DetailMiseEnForme({ miseEnForme }: DetailMiseEnFormeProps) {
  const { paragraphes, titreInvente, markdownAjoute, residus } = miseEnForme;
  return (
    <div className="mt-1 text-gray-700 text-small leading-normal">
      {paragraphes === undefined ? null : (
        <p>
          Paragraphes&nbsp;: {paragraphes.traduction} dans la traduction, {paragraphes.origine} dans
          le texte d'origine.
        </p>
      )}
      {titreInvente === true ? <p>Titre inventé&nbsp;: oui.</p> : null}
      {markdownAjoute === true ? <p>Markdown ajouté&nbsp;: oui.</p> : null}
      {residus.length === 0 ? null : <p>Résidus&nbsp;: {residus.join(', ')}.</p>}
    </div>
  );
}
